import { render, staticRenderFns } from "./employees-details.vue?vue&type=template&id=19c40df2"
import script from "./employees-details.vue?vue&type=script&lang=js"
export * from "./employees-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports